import { useQuery } from '@tanstack/react-query';
import api from './authService';

export const taxApi = {
  quote: async (payload) => {
    const response = await api.post('/tax/quote', payload);
    return response.data;
  },
};

/**
 * Live tax quote for checkout. Refetches when amount/country context changes.
 */
export const useTaxQuote = (payload, options = {}) => {
  const {
    subtotal,
    currency,
    event_country,
    billing_country,
    customer_type,
    customer_tax_id,
    enabled = true,
  } = payload || {};

  const hasCountry = Boolean(event_country || billing_country);

  return useQuery({
    queryKey: [
      'tax-quote',
      subtotal,
      currency,
      event_country,
      billing_country,
      customer_type,
      customer_tax_id,
    ],
    queryFn: () =>
      taxApi.quote({
        subtotal: Number(subtotal) || 0,
        currency: currency || 'USD',
        event_country: event_country || null,
        billing_country: billing_country || null,
        customer_type: customer_type || 'individual',
        customer_tax_id: customer_tax_id || null,
      }),
    enabled: enabled && hasCountry && Number(subtotal) >= 0,
    staleTime: 60 * 1000,
    retry: false,
    ...options,
  });
};
